import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import useAutomationId from '@/hooks/useAutomationId.ts';
import { STATIC_DATASET_USAGE_KEY } from '@/utils/queryKeys.ts';
import { StaticEditorUsage } from '@/types/datasets.ts';

export default function useStaticEditorUsage(sourceId: string, enabled: boolean) {
  const api = useApiClient();
  const automationId = useAutomationId();
  return useQuery({
    queryKey: [...STATIC_DATASET_USAGE_KEY(automationId), 'editor-summary', sourceId],
    queryFn: async ({ signal }) =>
      (await api.get<StaticEditorUsage>(`/datasets/static/${sourceId}/editor-usage`, { signal }))
        .data,
    enabled,
    staleTime: 0,
    refetchOnMount: 'always',
  });
}
